// import React, { useState } from 'react';
// import { IoChevronBack, IoChevronForward, IoCalendarOutline } from 'react-icons/io5';
// import { useFetch } from '../../../hooks/useFetch';
// import { useNavigate } from 'react-router-dom';
// import Loading from '../Loading';
// import ErrorMessage from '../ErrorMessage';
// import { getMediaURL } from '../../../utils/helpers';
// import { POPULATE_PARAMS } from '../../../config/constants';

// const Carousel = ({
//     title = 'Duyurular & Haberler',
//     itemsPerPage = 6,
//     endpoint = 'posts',
//     urlendpoint = 'basin/haberler',
//     bgColor = '#1e3a8a',
//     textColor = '#ffffff',
//     cardBgColor = '#ffffff',
//     cardTextColor = '#111111',
//     accentColor = '#1e3a8a'
// }) => {
//     const [page, setPage] = useState(0);
//     const [isMobile, setIsMobile] = useState(false);
//     const { data, loading, error } = useFetch(endpoint, POPULATE_PARAMS.CAROUSEL_WITH_IMAGES_SORTED_DESC(1, 20));
//     const navigate = useNavigate();
//     //console.log(data);
//     // Detect screen size
//     React.useEffect(() => {
//         const checkMobile = () => setIsMobile(window.innerWidth < 768);
//         checkMobile();
//         window.addEventListener('resize', checkMobile);
//         return () => window.removeEventListener('resize', checkMobile);
//     }, []);

//     const goToArticles = () => {
//         // Use documentId instead of id for Strapi v5
//         navigate(`/${urlendpoint}`);
//     };

//     if (loading) return <Loading />;
//     if (error) return <ErrorMessage message={error} />;

//     const currentItemsPerPage = isMobile ? 2 : itemsPerPage;
//     const totalPages = Math.ceil(data.length / currentItemsPerPage);
//     const items = data.slice(page * currentItemsPerPage, (page + 1) * currentItemsPerPage);

//     return (
//         <div
//             className="w-full px-4 py-8 sm:px-5 md:px-6 md:py-10 lg:py-10"
//             style={{ background: bgColor, color: textColor }}
//         >
//             <div className="max-w-[1200px] mx-auto w-full">

//                 {/* Header */}
//                 <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6 md:mb-8 gap-3 sm:gap-4">
//                     <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold m-0 relative cursor-pointer
//          after:content-[''] after:absolute after:left-0 after:bottom-0
//          after:h-[2px] after:w-0 after:bg-current
//          after:transition-all after:duration-300
//          hover:after:w-full" onClick={goToArticles}>
//                         {title}
//                     </h1>

//                     <div className="flex gap-2">
//                         <button
//                             onClick={() => setPage(p => Math.max(p - 1, 0))}
//                             disabled={page === 0}
//                             className={`w-10 h-10 md:w-12 md:h-12 rounded-full border-none transition-all duration-300 flex items-center justify-center
//                                 ${page === 0
//                                     ? 'bg-white/20 cursor-not-allowed opacity-50'
//                                     : 'bg-white/30 hover:bg-white/50 cursor-pointer hover:scale-110'
//                                 }`}
//                             style={{ color: textColor }}
//                             aria-label="Previous page"
//                         >
//                             <IoChevronBack size={22} />
//                         </button>

//                         <button
//                             onClick={() => setPage(p => Math.min(p + 1, totalPages - 1))}
//                             disabled={page === totalPages - 1}
//                             className={`w-10 h-10 md:w-12 md:h-12 rounded-full border-none transition-all duration-300 flex items-center justify-center
//                                 ${page === totalPages - 1
//                                     ? 'bg-white/20 cursor-not-allowed opacity-50'
//                                     : 'bg-white/30 hover:bg-white/50 cursor-pointer hover:scale-110'
//                                 }`}
//                             style={{ color: textColor }}
//                             aria-label="Next page"
//                         >
//                             <IoChevronForward size={22} />
//                         </button>
//                     </div>
//                 </div>

//                 {/* Grid */}
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 md:gap-6">
//                     {items.map(item => (
//                         <div
//                             key={item.id}
//                             className="rounded-xl overflow-hidden flex flex-col shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer group"
//                             style={{ background: cardBgColor }}
//                             onClick={() => navigate(`/${urlendpoint}/${item.slug}`)}
//                         >
//                             {/* Image */}
//                             <div className="w-full h-40 sm:h-44 md:h-48 overflow-hidden relative flex-shrink-0">
//                                 <img
//                                     src={getMediaURL(item.image) || 'https://placehold.co/300'}
//                                     alt={item.title}
//                                     className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
//                                 />
//                                 <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
//                             </div>

//                             {/* Content */}
//                             <div className="p-4 md:p-5 flex flex-col flex-1">
//                                 <h3
//                                     className="text-base md:text-lg font-semibold mb-2 sm:mb-3 line-clamp-2 group-hover:text-opacity-80 transition-colors"
//                                     style={{ color: cardTextColor }}
//                                 >
//                                     {item.title}
//                                 </h3>

//                                 <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-0 mt-auto pt-2 sm:pt-3 border-t border-gray-200">
//                                     <span className="flex items-center gap-1.5 text-xs md:text-sm text-gray-500">
//                                         <IoCalendarOutline size={16} />
//                                         {new Date(item.publishedAt).toLocaleDateString('tr-TR')}
//                                     </span>

//                                     <button
//                                         className="flex items-center gap-1 text-xs md:text-sm font-semibold transition-all duration-300 group-hover:gap-2 self-start sm:self-auto"
//                                         style={{ color: accentColor }}
//                                         onClick={(e) => {
//                                             e.stopPropagation();
//                                             //navigate(`/${endpoint}/${item.documentId}`);
//                                             //navigate(`/${endpoint}/${item.slug}`);
//                                             navigate(`/${urlendpoint}/${item.slug}`);

//                                         }}
//                                         aria-label={`Read more about ${item.title}`}
//                                     >
//                                         Devamı
//                                         <IoChevronForward size={15} className="transition-transform group-hover:translate-x-1" />
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>

//                 {/* Pagination */}
//                 <div className="mt-6 sm:mt-8 md:mt-12 flex justify-center gap-2">
//                     {Array.from({ length: totalPages }).map((_, i) => (
//                         <button
//                             key={i}
//                             onClick={() => setPage(i)}
//                             className={`h-2 rounded-full border-none cursor-pointer transition-all duration-300 hover:opacity-80
//                                 ${i === page ? 'w-8 md:w-10' : 'w-2'}`}
//                             style={{
//                                 background: i === page ? textColor : 'rgba(255,255,255,0.4)'
//                             }}
//                             aria-label={`Go to page ${i + 1}`}
//                         />
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Carousel;



// import React, { useState } from 'react';
// import { IoChevronBack, IoChevronForward, IoCalendarOutline } from 'react-icons/io5';
// import { useFetch } from '../../../hooks/useFetch';
// import { useNavigate } from 'react-router-dom';
// import Loading from '../Loading';
// import ErrorMessage from '../ErrorMessage';
// import { getMediaURL } from '../../../utils/helpers';
// import { POPULATE_PARAMS } from '../../../config/constants';

// const Carousel = ({
//     title = 'Duyurular & Haberler',
//     itemsPerPage = 6,
//     endpoint = 'posts',
//     urlendpoint = 'basin/haberler',
//     bgColor = '#1e3a8a',
//     textColor = '#ffffff',
//     cardBgColor = '#ffffff',
//     cardTextColor = '#111111',
//     accentColor = '#1e3a8a',
//     cardLayout = 'vert' // 'vert' or 'hor'
// }) => {
//     const [page, setPage] = useState(0);
//     const [isMobile, setIsMobile] = useState(false);
//     const { data, loading, error } = useFetch(endpoint, POPULATE_PARAMS.CAROUSEL_WITH_IMAGES_SORTED_DESC(1, 20));
//     const navigate = useNavigate();

//     // Detect screen size
//     React.useEffect(() => {
//         const checkMobile = () => setIsMobile(window.innerWidth < 768);
//         checkMobile();
//         window.addEventListener('resize', checkMobile);
//         return () => window.removeEventListener('resize', checkMobile);
//     }, []);

//     const goToArticles = () => {
//         navigate(`/${urlendpoint}`);
//     };

//     if (loading) return <Loading />;
//     if (error) return <ErrorMessage message={error} />;

//     const currentItemsPerPage = isMobile ? 2 : itemsPerPage;
//     const totalPages = Math.ceil(data.length / currentItemsPerPage);
//     const items = data.slice(page * currentItemsPerPage, (page + 1) * currentItemsPerPage);

//     // Determine grid layout based on cardLayout
//     const gridClass = cardLayout === 'hor'
//         ? 'grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6'
//         : 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 md:gap-6';

//     return (
//         <div
//             className="w-full px-4 py-8 sm:px-5 md:px-6 md:py-10 lg:py-10"
//             style={{ background: bgColor, color: textColor }}
//         >
//             <div className="max-w-[1200px] mx-auto w-full">

//                 {/* Header */}
//                 <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6 md:mb-8 gap-3 sm:gap-4">
//                     <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold m-0 relative cursor-pointer
//          after:content-[''] after:absolute after:left-0 after:bottom-0
//          after:h-[2px] after:w-0 after:bg-current
//          after:transition-all after:duration-300
//          hover:after:w-full" onClick={goToArticles}>
//                         {title}
//                     </h1>

//                     <div className="flex gap-2">
//                         <button
//                             onClick={() => setPage(p => Math.max(p - 1, 0))}
//                             disabled={page === 0}
//                             className={`w-10 h-10 md:w-12 md:h-12 rounded-full border-none transition-all duration-300 flex items-center justify-center
//                                 ${page === 0
//                                     ? 'bg-white/20 cursor-not-allowed opacity-50'
//                                     : 'bg-white/30 hover:bg-white/50 cursor-pointer hover:scale-110'
//                                 }`}
//                             style={{ color: textColor }}
//                             aria-label="Previous page"
//                         >
//                             <IoChevronBack size={22} />
//                         </button>

//                         <button
//                             onClick={() => setPage(p => Math.min(p + 1, totalPages - 1))}
//                             disabled={page === totalPages - 1}
//                             className={`w-10 h-10 md:w-12 md:h-12 rounded-full border-none transition-all duration-300 flex items-center justify-center
//                                 ${page === totalPages - 1
//                                     ? 'bg-white/20 cursor-not-allowed opacity-50'
//                                     : 'bg-white/30 hover:bg-white/50 cursor-pointer hover:scale-110'
//                                 }`}
//                             style={{ color: textColor }}
//                             aria-label="Next page"
//                         >
//                             <IoChevronForward size={22} />
//                         </button>
//                     </div>
//                 </div>

//                 {/* Grid */}
//                 <div className={gridClass}>
//                     {items.map(item => (
//                         <div
//                             key={item.id}
//                             className="cursor-pointer group"
//                             onClick={() => navigate(`/${urlendpoint}/${item.slug}`)}
//                         >
//                             {/* Vertical Layout - Original */}
//                             {cardLayout === 'vert' && (
//                                 <div
//                                     className="flex flex-col h-full rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
//                                     style={{ background: cardBgColor }}
//                                 >
//                                     <div className="w-full h-40 sm:h-44 md:h-48 overflow-hidden relative flex-shrink-0">
//                                         <img
//                                             // src={getMediaURL(item.image) || 'https://placehold.co/300'}
//                                             src={item?.image ? getMediaURL(item.image) : '/placeholder_hor.jpg'}
//                                             alt={item.title}
//                                             className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
//                                         />
//                                         <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
//                                     </div>

//                                     <div className="p-4 md:p-5 flex flex-col flex-1">
//                                         <h3
//                                             className="text-base md:text-lg font-semibold mb-2 sm:mb-3 line-clamp-2 group-hover:text-opacity-80 transition-colors"
//                                             style={{ color: cardTextColor }}
//                                         >
//                                             {item.title}
//                                         </h3>

//                                         <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-0 mt-auto pt-2 sm:pt-3 border-t border-gray-200">
//                                             <span className="flex items-center gap-1.5 text-xs md:text-sm text-gray-500">
//                                                 <IoCalendarOutline size={16} />
//                                                 {new Date(item.publishedAt).toLocaleDateString('tr-TR')}
//                                             </span>

//                                             <button
//                                                 className="flex items-center gap-1 text-xs md:text-sm font-semibold transition-all duration-300 group-hover:gap-2 self-start sm:self-auto whitespace-nowrap"
//                                                 style={{ color: accentColor }}
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     navigate(`/${urlendpoint}/${item.slug}`);
//                                                 }}
//                                                 aria-label={`Read more about ${item.title}`}
//                                             >
//                                                 Devamı
//                                                 <IoChevronForward size={15} className="transition-transform group-hover:translate-x-1" />
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </div>
//                             )}


//                             {/* Horizontal Layout - Book/Publication Style */}
//                             {cardLayout === 'hor' && (
//                                 <div className="flex flex-col">
//                                     {/* Book Cover Image */}
//                                     <div className="w-full overflow-hidden relative rounded-lg mb-4 shadow-md group-hover:shadow-xl transition-all duration-300">
//                                         <img
//                                             src={item?.image ? getMediaURL(item.image) : '/placeholder_vert.jpg'}
//                                             alt={item.title}
//                                             className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
//                                             style={{ aspectRatio: '3/4' }}
//                                         />
//                                     </div>

//                                     {/* Title Below */}
//                                     <h3
//                                         className="text-sm md:text-base font-medium line-clamp-2 px-1"
//                                         style={{ color: cardTextColor }}
//                                     >
//                                         {item.title}
//                                     </h3>
//                                 </div>
//                             )}
//                         </div>
//                     ))}
//                 </div>

//                 {/* Pagination */}
//                 {totalPages > 1 && (
//                     <div className="mt-6 sm:mt-8 md:mt-12 flex justify-center gap-2">
//                         {Array.from({ length: totalPages }).map((_, i) => (
//                             <button
//                                 key={i}
//                                 onClick={() => setPage(i)}
//                                 className={`h-2 rounded-full border-none cursor-pointer transition-all duration-300 hover:opacity-80
//                                     ${i === page ? 'w-8 md:w-10' : 'w-2'}`}
//                                 style={{
//                                     background: i === page ? textColor : 'rgba(255,255,255,0.4)'
//                                 }}
//                                 aria-label={`Go to page ${i + 1}`}
//                             />
//                         ))}
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default Carousel;






// import React, { useState, useEffect } from 'react';
// import { IoChevronBack, IoChevronForward, IoCalendarOutline } from 'react-icons/io5';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination, Grid, Autoplay } from 'swiper/modules';
// import { useFetch } from '../../../hooks/useFetch';
// import { useNavigate } from 'react-router-dom';
// import Loading from '../Loading';
// import ErrorMessage from '../ErrorMessage';
// import { getMediaURL } from '../../../utils/helpers';
// import { POPULATE_PARAMS } from '../../../config/constants';
// import { toTurkishDate } from '../../../utils/dateConvertToTr'

// // Import Swiper styles
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/grid';

// const Carousel = ({
//     title = 'Duyurular & Haberler',
//     itemsPerPage = 6,
//     endpoint = 'posts',
//     urlendpoint = 'basin/haberler',
//     bgColor = '#1e3a8a',
//     textColor = '#ffffff',
//     cardBgColor = '#ffffff',
//     cardTextColor = '#111111',
//     accentColor = '#1e3a8a',
//     cardLayout = 'vert' // 'vert' or 'hor'
// }) => {
//     const [swiperInstance, setSwiperInstance] = useState(null);
//     const { data, loading, error } = useFetch(endpoint, POPULATE_PARAMS.CAROUSEL_WITH_IMAGES_SORTED_DESC(1, 20));
//     const navigate = useNavigate();

//     const goToArticles = () => {
//         navigate(`/${urlendpoint}`);
//     };

//     if (loading) return <Loading />;
//     if (error) return <ErrorMessage message={error} />;

//     // Calculate proper slidesPerGroup based on grid rows
//     const getBreakpointConfig = () => {
//         if (cardLayout === 'hor') {
//             return {
//                 320: {
//                     slidesPerView: 2,
//                     slidesPerGroup: 1,
//                     spaceBetween: 16,
//                     grid: { rows: 1, fill: 'row' }
//                 },
//                 640: {
//                     slidesPerView: 3,
//                     slidesPerGroup: 3,
//                     spaceBetween: 16,
//                     grid: { rows: 1, fill: 'row' }
//                 },
//                 768: {
//                     slidesPerView: 3,
//                     slidesPerGroup: 3,
//                     spaceBetween: 20,
//                     grid: { rows: 1, fill: 'row' }
//                 },
//                 1024: {
//                     slidesPerView: 4,
//                     slidesPerGroup: 4,
//                     spaceBetween: 24,
//                     grid: { rows: 1, fill: 'row' }
//                 },
//                 1280: {
//                     slidesPerView: 5,
//                     slidesPerGroup: 5,
//                     spaceBetween: 24,
//                     grid: { rows: 1, fill: 'row' }
//                 }
//             };
//         } else {
//             // Vertical layout with 2 rows
//             return {
//                 320: {
//                     slidesPerView: 1,
//                     slidesPerGroup: 1, // 2 columns × 2 rows
//                     spaceBetween: 20,
//                     grid: { rows: 2, fill: 'row' }
//                 },
//                 640: {
//                     slidesPerView: 1,
//                     slidesPerGroup: 1, // 2 columns × 2 rows
//                     spaceBetween: 20,
//                     grid: { rows: 2, fill: 'row' }
//                 },
//                 768: {
//                     slidesPerView: 3,
//                     slidesPerGroup: 3, // 3 columns × 2 rows
//                     spaceBetween: 24,
//                     grid: { rows: 2, fill: 'row' }
//                 },
//                 1024: {
//                     slidesPerView: 3,
//                     slidesPerGroup: 3, // 3 columns × 2 rows
//                     spaceBetween: 24,
//                     grid: { rows: 2, fill: 'row' }
//                 },
//                 1280: {
//                     slidesPerView: 3,
//                     slidesPerGroup: 3, // 3 columns × 2 rows
//                     spaceBetween: 24,
//                     grid: { rows: 2, fill: 'row' }
//                 }
//             };
//         }
//     };

//     // Check if we have enough slides for loop mode
//     // Loop requires at least 2x the slides per view
//     const hasEnoughSlidesForLoop = () => {
//         const maxSlidesPerGroup = cardLayout === 'vert' ? 6 : 5;
//         return data.length >= maxSlidesPerGroup * 2;
//     };

//     return (
//         <div
//             className="w-full px-4 py-8 sm:px-5 md:px-6 md:py-10 lg:py-10"
//             style={{ background: bgColor, color: textColor }}
//         >
//             <div className="max-w-[1200px] mx-auto w-full">

//                 {/* Header */}
//                 <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6 md:mb-8 gap-3 sm:gap-4">
//                     <h1
//                         className="text-2xl md:text-3xl lg:text-4xl font-bold m-0 relative cursor-pointer
//                             after:content-[''] after:absolute after:left-0 after:bottom-0
//                             after:h-[2px] after:w-0 after:bg-current
//                             after:transition-all after:duration-300
//                             hover:after:w-full"
//                         onClick={goToArticles}
//                     >
//                         {title}
//                     </h1>

//                     <div className="flex gap-2">
//                         <button
//                             onClick={() => swiperInstance?.slidePrev()}
//                             className="w-10 h-10 md:w-12 md:h-12 rounded-full border-none transition-all duration-300 flex items-center justify-center
//                                 bg-white/30 hover:bg-white/50 cursor-pointer hover:scale-110 disabled:opacity-50 disabled:cursor-not-allowed"
//                             style={{ color: textColor }}
//                             aria-label="Previous page"
//                             disabled={!swiperInstance}
//                         >
//                             <IoChevronBack size={22} />
//                         </button>

//                         <button
//                             onClick={() => swiperInstance?.slideNext()}
//                             className="w-10 h-10 md:w-12 md:h-12 rounded-full border-none transition-all duration-300 flex items-center justify-center
//                                 bg-white/30 hover:bg-white/50 cursor-pointer hover:scale-110 disabled:opacity-50 disabled:cursor-not-allowed"
//                             style={{ color: textColor }}
//                             aria-label="Next page"
//                             disabled={!swiperInstance}
//                         >
//                             <IoChevronForward size={22} />
//                         </button>
//                     </div>
//                 </div>

//                 {/* Swiper */}
//                 <Swiper
//                     modules={[Navigation, Pagination, Grid, Autoplay]}
//                     spaceBetween={20}
//                     slidesPerView={2}
//                     slidesPerGroup={cardLayout === 'vert' ? 2 : 1}
//                     grid={{
//                         rows: cardLayout === 'vert' ? 2 : 1,
//                         fill: 'row'
//                     }}
//                     speed={1200}

//                     autoplay={{
//                         delay: 10000,
//                         disableOnInteraction: false,
//                         pauseOnMouseEnter: true,
//                     }}
//                     loop={hasEnoughSlidesForLoop()}
//                     loopfillgroupwithblank='false'
//                     onSwiper={setSwiperInstance}
//                     pagination={{
//                         clickable: true,
//                         dynamicBullets: false,
//                         bulletClass: 'swiper-pagination-bullet',
//                         bulletActiveClass: 'swiper-pagination-bullet-active',
//                         renderBullet: (index, className) => {
//                             return `<span class="${className}" style="background: ${textColor};"></span>`;
//                         }
//                     }}
//                     breakpoints={getBreakpointConfig()}
//                     className="!pb-12"
//                 >
//                     {data.map(item => (
//                         <SwiperSlide key={item.id}>
//                             <div
//                                 className="cursor-pointer group h-full"
//                                 onClick={() => navigate(`/${urlendpoint}/${item.slug}`)}
//                             >
//                                 {/* Vertical Layout - Original */}
//                                 {cardLayout === 'vert' && (
//                                     <div
//                                         // className="flex flex-col h-full rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
//                                         className="flex flex-col h-full rounded-xl overflow-hidden shadow-lg hover:shadow-2xl"
//                                         style={{ background: cardBgColor }}
//                                     >
//                                         <div className="w-full h-40 sm:h-44 md:h-48 overflow-hidden relative">
//                                             <img
//                                                 src={item?.image ? getMediaURL(item.image) : '/placeholder_hor.jpg'}
//                                                 alt={item.title}
//                                                 className="w-full h-full object-cover "
//                                             />
//                                             <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
//                                         </div>

//                                         <div className="p-4 md:p-5 flex flex-col flex-1">
//                                             <h3
//                                                 className="text-base md:text-lg font-semibold mb-2 sm:mb-3 line-clamp-2 group-hover:text-opacity-80 transition-colors"
//                                                 style={{ color: cardTextColor }}
//                                             >
//                                                 {item.title}
//                                             </h3>

//                                             <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-0 mt-auto pt-2 sm:pt-3 border-t border-gray-200">
//                                                 <span className="flex items-center gap-1.5 text-xs md:text-sm text-gray-500">
//                                                     <IoCalendarOutline size={16} />
//                                                     {toTurkishDate(item.publishedAt)}
//                                                 </span>

//                                                 <button
//                                                     className="flex items-center gap-1 text-xs md:text-sm font-semibold transition-all duration-300 group-hover:gap-2 self-start sm:self-auto whitespace-nowrap"
//                                                     style={{ color: accentColor }}
//                                                     onClick={(e) => {
//                                                         e.stopPropagation();
//                                                         navigate(`/${urlendpoint}/${item.slug}`);
//                                                     }}
//                                                     aria-label={`Read more about ${item.title}`}
//                                                 >
//                                                     Devamı
//                                                     <IoChevronForward size={15} className="transition-transform group-hover:translate-x-1" />
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}

//                                 {/* Horizontal Layout - Book/Publication Style */}
//                                 {cardLayout === 'hor' && (
//                                     <div className="flex flex-col h-full">
//                                         {/* Book Cover Image */}
//                                         <div className="w-full overflow-hidden relative rounded-lg mb-4 shadow-md group-hover:shadow-xl transition-all duration-300">
//                                             <img
//                                                 src={item?.image ? getMediaURL(item.image) : '/placeholder_vert.jpg'}
//                                                 alt={item.title}
//                                                 className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
//                                                 style={{ aspectRatio: '3/4' }}
//                                             />
//                                         </div>

//                                         {/* Title Below */}
//                                         <h3
//                                             className="text-sm md:text-base font-medium line-clamp-2 px-1"
//                                             style={{ color: cardTextColor }}
//                                         >
//                                             {item.title}
//                                         </h3>
//                                     </div>
//                                 )}
//                             </div>
//                         </SwiperSlide>
//                     ))}
//                 </Swiper>

//                 {/* Custom Pagination Styles */}
//                 <style jsx>{`
//                     .swiper-pagination {
//                         bottom: 0 !important;
//                         display: flex !important;
//                         justify-content: center !important;
//                         align-items: center !important;
//                         gap: 8px !important;
//                     }
//                     .swiper-pagination-bullet {
//                         width: 8px;
//                         height: 8px;
//                         border-radius: 9999px;
//                         cursor: pointer;
//                         transition: all 0.3s;
//                         opacity: 0.4;
//                         margin: 0 !important;
//                     }
//                     .swiper-pagination-bullet-active {
//                         width: 32px !important;
//                         opacity: 1 !important;
//                     }
//                     @media (min-width: 768px) {
//                         .swiper-pagination-bullet-active {
//                             width: 40px !important;
//                         }
//                     }
//                     .swiper-pagination-bullet:hover {
//                         opacity: 0.8 !important;
//                     }
//                     .swiper-slide {
//                         height: auto !important;
//                         display: flex !important;
//                     }
//                     .swiper-slide > div {
//                         width: 100%;
//                     }
//                 `}</style>
//             </div>
//         </div>
//     );
// };

// export default Carousel;



import React, { useState, useEffect } from 'react';
import { IoChevronBack, IoChevronForward, IoCalendarOutline } from 'react-icons/io5';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Grid, Autoplay } from 'swiper/modules';
import { useFetch } from '../../../hooks/useFetch';
import { useNavigate } from 'react-router-dom';
import Loading from '../Loading';
import ErrorMessage from '../ErrorMessage';
import { getMediaURL } from '../../../utils/helpers';
import { POPULATE_PARAMS } from '../../../config/constants';
import { toTurkishDate } from '../../../utils/dateConvertToTr'

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/grid';

const Carousel = ({
    title = 'Duyurular & Haberler',
    itemsPerPage = 6,
    endpoint = 'posts',
    urlendpoint = 'basin/haberler',
    bgColor = '#1e3a8a',
    textColor = '#ffffff',
    cardBgColor = '#ffffff',
    cardTextColor = '#111111',
    accentColor = '#1e3a8a',
    cardLayout = 'vert' // 'vert' or 'hor'
}) => {
    const [swiperInstance, setSwiperInstance] = useState(null);
    const { data, loading, error } = useFetch(endpoint, POPULATE_PARAMS.CAROUSEL_WITH_IMAGES_SORTED_DESC(1, 20));
    const navigate = useNavigate();

    const goToArticles = () => {
        navigate(`/${urlendpoint}`);
    };

    if (loading) return <Loading />;
    if (error) return <ErrorMessage message={error} />;

    // Calculate proper slidesPerGroup based on grid rows
    const getBreakpointConfig = () => {
        if (cardLayout === 'hor') {
            return {
                320: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                    spaceBetween: 16,
                    grid: { rows: 1, fill: 'row' }
                },
                640: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 16,
                    grid: { rows: 1, fill: 'row' }
                },
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 20,
                    grid: { rows: 1, fill: 'row' }
                },
                1024: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    spaceBetween: 24,
                    grid: { rows: 1, fill: 'row' }
                },
                1280: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                    spaceBetween: 24,
                    grid: { rows: 1, fill: 'row' }
                }
            };
        } else {
            // Vertical layout with 2 rows
            return {
                320: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 20,
                    grid: { rows: 2, fill: 'row' }
                },
                640: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 20,
                    grid: { rows: 2, fill: 'row' }
                },
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 24,
                    grid: { rows: 2, fill: 'row' }
                },
                1024: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 24,
                    grid: { rows: 2, fill: 'row' }
                },
                1280: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 24,
                    grid: { rows: 2, fill: 'row' }
                }
            };
        }
    };

    // Check if we have enough slides for loop mode
    // Loop requires at least 2x the slides per view
    const hasEnoughSlidesForLoop = () => {
        // FIX: Loop is incompatible with Grid if rows > 1
        if (cardLayout === 'vert') return false;

        const maxSlidesPerGroup = 5; // Max slides for 'hor'
        return data.length >= maxSlidesPerGroup * 2;
    };

    return (
        <div
            className="w-full px-4 py-8 sm:px-5 md:px-6 md:py-10 lg:py-10"
            style={{ background: bgColor, color: textColor }}
        >
            <div className="max-w-[1200px] mx-auto w-full">

                {/* Header */}
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6 md:mb-8 gap-3 sm:gap-4">
                    <h1
                        className="text-2xl md:text-3xl lg:text-4xl font-bold m-0 relative cursor-pointer
                            after:content-[''] after:absolute after:left-0 after:bottom-0
                            after:h-[2px] after:w-0 after:bg-current
                            after:transition-all after:duration-300
                            hover:after:w-full"
                        onClick={goToArticles}
                    >
                        {title}
                    </h1>

                    <div className="flex gap-2">
                        <button
                            onClick={() => swiperInstance?.slidePrev()}
                            className="w-10 h-10 md:w-12 md:h-12 rounded-full border-none transition-all duration-300 flex items-center justify-center
                                bg-white/30 hover:bg-white/50 cursor-pointer hover:scale-110 disabled:opacity-50 disabled:cursor-not-allowed"
                            style={{ color: textColor }}
                            aria-label="Previous page"
                            disabled={!swiperInstance}
                        >
                            <IoChevronBack size={22} />
                        </button>

                        <button
                            onClick={() => swiperInstance?.slideNext()}
                            className="w-10 h-10 md:w-12 md:h-12 rounded-full border-none transition-all duration-300 flex items-center justify-center
                                bg-white/30 hover:bg-white/50 cursor-pointer hover:scale-110 disabled:opacity-50 disabled:cursor-not-allowed"
                            style={{ color: textColor }}
                            aria-label="Next page"
                            disabled={!swiperInstance}
                        >
                            <IoChevronForward size={22} />
                        </button>
                    </div>
                </div>

                {/* Swiper */}
                <Swiper
                    modules={[Navigation, Pagination, Grid, Autoplay]}
                    spaceBetween={20}
                    slidesPerView={2}
                    slidesPerGroup={cardLayout === 'vert' ? 2 : 1}
                    grid={{
                        rows: cardLayout === 'vert' ? 2 : 1,
                        fill: 'row'
                    }}
                    speed={1200}
                    autoplay={{
                        delay: 10000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    // FIX: Ensure loop is strictly disabled for multi-row layouts
                    loop={hasEnoughSlidesForLoop()}
                    // FIX: CamelCase and passing boolean instead of string
                    loopfillgroupwithblank='false'
                    onSwiper={setSwiperInstance}
                    pagination={{
                        clickable: true,
                        dynamicBullets: false,
                        bulletClass: 'swiper-pagination-bullet',
                        bulletActiveClass: 'swiper-pagination-bullet-active',
                        renderBullet: (index, className) => {
                            return `<span class="${className}" style="background: ${textColor};"></span>`;
                        }
                    }}
                    breakpoints={getBreakpointConfig()}
                    className="!pb-12"
                >
                    {data.map(item => (
                        <SwiperSlide key={item.id}>
                            <div
                                className="cursor-pointer group h-full"
                                onClick={() => navigate(`/${urlendpoint}/${item.slug}`)}
                            >
                                {/* Vertical Layout - Original */}
                                {cardLayout === 'vert' && (
                                    <div
                                        className="flex flex-col h-full rounded-xl overflow-hidden shadow-lg hover:shadow-2xl"
                                        style={{ background: cardBgColor }}
                                    >
                                        <div className="w-full h-40 sm:h-44 md:h-48 overflow-hidden relative">
                                            <img
                                                src={item?.image ? getMediaURL(item.image) : '/placeholder_hor.jpg'}
                                                alt={item.title}
                                                className="w-full h-full object-cover "
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                                        </div>

                                        <div className="p-4 md:p-5 flex flex-col flex-1">
                                            <h3
                                                className="text-base md:text-lg font-semibold mb-2 sm:mb-3 line-clamp-2 group-hover:text-opacity-80 transition-colors"
                                                style={{ color: cardTextColor }}
                                            >
                                                {item.title}
                                            </h3>

                                            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-0 mt-auto pt-2 sm:pt-3 border-t border-gray-200">
                                                <span className="flex items-center gap-1.5 text-xs md:text-sm text-gray-500">
                                                    <IoCalendarOutline size={16} />
                                                    {toTurkishDate(item.publishedAt)}
                                                </span>

                                                <button
                                                    className="flex items-center gap-1 text-xs md:text-sm font-semibold transition-all duration-300 group-hover:gap-2 self-start sm:self-auto whitespace-nowrap"
                                                    style={{ color: accentColor }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        navigate(`/${urlendpoint}/${item.slug}`);
                                                    }}
                                                    aria-label={`Read more about ${item.title}`}
                                                >
                                                    Devamı
                                                    <IoChevronForward size={15} className="transition-transform group-hover:translate-x-1" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Horizontal Layout - Book/Publication Style */}
                                {cardLayout === 'hor' && (
                                    <div className="flex flex-col h-full">
                                        <div className="w-full overflow-hidden relative rounded-lg mb-4 shadow-md group-hover:shadow-xl transition-all duration-300">
                                            <img
                                                src={item?.image ? getMediaURL(item.image) : '/placeholder_vert.jpg'}
                                                alt={item.title}
                                                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                                                style={{ aspectRatio: '3/4' }}
                                            />
                                        </div>

                                        <h3
                                            className="text-sm md:text-base font-medium line-clamp-2 px-1"
                                            style={{ color: cardTextColor }}
                                        >
                                            {item.title}
                                        </h3>
                                    </div>
                                )}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Custom Pagination Styles - FIX: Removed 'jsx' attribute */}
                <style>{`
                    .swiper-pagination {
                        bottom: 0 !important;
                        display: flex !important;
                        justify-content: center !important;
                        align-items: center !important;
                        gap: 8px !important;
                    }
                    .swiper-pagination-bullet {
                        width: 8px;
                        height: 8px;
                        border-radius: 9999px;
                        cursor: pointer;
                        transition: all 0.3s;
                        opacity: 0.4;
                        margin: 0 !important;
                    }
                    .swiper-pagination-bullet-active {
                        width: 32px !important;
                        opacity: 1 !important;
                    }
                    @media (min-width: 768px) {
                        .swiper-pagination-bullet-active {
                            width: 40px !important;
                        }
                    }
                    .swiper-pagination-bullet:hover {
                        opacity: 0.8 !important;
                    }
                    .swiper-slide {
                        height: auto !important;
                        display: flex !important;
                    }
                    .swiper-slide > div {
                        width: 100%;
                    }
                `}</style>
            </div>
        </div>
    );
};

export default Carousel;